import { useParams } from "react-router";

import { ActivityByAppV2 } from "../shared";

export const AppActivityPage = () => {
  const { id = "" } = useParams();
  return <ActivityByAppV2 appId={id} />;
};
